<template>
  <v-container>
    <h2>{{ isTeacher ? "Teacher" : "Student" }}</h2>
    <app-base
      ref="crud"
      :source="source"
      :post="post"
      :tableHeader="headers"
      @edit="onEdit"
      @remove="onRemove"
      @activeChanged="onActive"
    >
      <template v-slot:title>{{ isTeacher ? "Create Teacher" : "Create Student" }}</template>
      <template v-slot:form>
        <v-text-field
          id="first_name"
          v-model="name"
          label="First Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Name required']"
        />
        <v-text-field
          id="last_name"
          v-model="lastname"
          label="Last Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Last Name required']"
        />
        <v-text-field
          id="email"
          v-model="email"
          label="Email"
          outlined
          dense
          :rules="[(v) => !!v || 'Email required', rules.email]"
        />
        <v-text-field
          id="username"
          v-model="username"
          label="Username"
          outlined
          dense
          :rules="[(v) => !!v || 'Username required']"
        />
        <v-text-field
          id="password"
          v-model="password"
          label="Password"
          :type="revealPassword ? '' : 'password'"
          outlined
          dense
          :rules="[(v) => !!v || 'Password required']"
          :append-icon="revealPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="revealPassword = !revealPassword"
        />
        <v-autocomplete
          v-if="!isTeacher"
          v-model="level"
          :items="levels"
          item-text="name"
          item-value="uuid"
          id="level"
          dense
          outlined
          label="Initial Level"
          :rules="[(v) => !!v || 'Initial Level required']"
        />
        <v-file-input
          show-size
          v-model="avatar"
          id="avatar"
          label="Avatar"
          outlined
          dense
          accept="image/*"
          prepend-icon
          append-icon="mdi-account"
        />
      </template>
    </app-base>
    <app-teacher-edit v-model="editDialog" @teacher-updated="onTeacherUpdate" />
    <app-student-edit v-model="studentDialog" @update-student="onStudentUpdate" />
    <app-confirm-dialog v-model="removeDialog" @yes="onYes" :loading="removeLoading" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import Base from "./Base.vue";
import TeacherEdit from "./Teacher Edit.vue";
import StudentEdit from "./StudentEdit.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {
  postStudents,
  getStudents,
  getTeachers,
  postTeachers,
  getLevels,
  removeStudent,
  removeTeacher,
  patchProfile,
} from "@/api/api";
import removeMixin from "@/mixins/removeMixin";

export default {
  components: {
    appBase: Base,
    appTeacherEdit: TeacherEdit,
    appStudentEdit: StudentEdit,
    appConfirmDialog: ConfirmDialog,
  },
  props: {
    isTeacher: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  mixins: [removeMixin],
  data() {
    return {
      rules: {
        email: (v) => {
          const re =
            /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return "Must be a valid e-mail.";
        },
      },
      name: "",
      lastname: "",
      email: "",
      username: "",
      password: "",
      level: "",
      avatar: undefined,
      getStudents,
      postStudents,
      getTeachers,
      postTeachers,
      revealPassword: false,
      headers: [
        { text: "Email", value: "email", align: "left" },
        { text: "Name", value: "fullName", align: "right" },
        { text: "", value: "button", align: "right" },
        { text: "Active", value: "is_active", align: "center" },
        { text: "Edit email", value: "edit_email", align: "center" },
        { text: "Edit password", value: "edit_password", align: "center" },
        // { text: 'Remove', value: 'remove', align: 'center' },
      ],
      editDialog: false,
      studentDialog: false,
      levels: [],
      remover: removeStudent,
    };
  },
  computed: {
    source() {
      if (this.isTeacher) return getTeachers;
      return getStudents;
    },
    post() {
      if (this.isTeacher) return postTeachers;
      return postStudents;
    },
  },
  methods: {
    onEdit(e) {
      if (e.role === "STUDENT") {
        this.$store.commit("admin/student", e);
        this.studentDialog = true;
      } else {
        this.$store.commit("admin/teacher", e);
        this.editDialog = true;
      }
    },
    onStudentUpdate(e) {
      this.onTeacherUpdate(e);
    },
    onTeacherUpdate(e) {
      for (let index = 0; index < this.$refs.crud.$refs.pag.data.results.length; index++) {
        let element = this.$refs.crud.$refs.pag.data.results[index];
        if (element.uuid === e.uuid) {
          this.$refs.crud.$refs.pag.data.results.splice(index, 1, e);
        }
      }
    },
    async onActive({ value, item }) {
      const response = await patchProfile({
        uuid: item.uuid,
        is_active: value,
      });
      if (!response) item.is_active = !value;
    },
  },
  async created() {
    if (this.isTeacher) {
      this.remover = removeTeacher;
    }
    const response = await getLevels();
    if (response) {
      this.levels = response.data;
    }
  },
};
</script>
